<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Filters',
        body: [
          `The filters allow the user to search for a specific district,
          school, and/or batch number. The user can also select a date
          process range. The date process range defaults to the past 30 days.
          If the user wishes to locate canceled records which are older than
          30 days, the user must change the date range accordingly. If the
          person has access to more than one person type, the user may select
          the person type in the filters. Persons with access to multiple
          districts or schools will have the ability to select one or more
          district/school options. Finally, the person can select one or more
          Canceled Record Statuses.`,
        ],
      },
      {
        header: 'Running the Report',
        body: [
          `Once the user has selected the desired parameters, click Customize.
          The Canceled Records Report Results panel will appear. This panel
          contains a summary header with the total person type count, user
          count, district count, batch count and canceled record count. If the
          user has access or selected more than one district the district
          location information will appear along with the school count, batch
          count, user count, canceled records count and an action icon. The
          user can drill into the district level by clicking the action icon.`,
        ],
      },
      {
        header: 'Drilling into the Report',
        body: [
          `On the Canceled Records Report Results panel, the user can drill
          into the district profile by clicking the hyperlinked district name
          or drill into the canceled record data by clicking the double
          arrow, drill in icon under Actions. Drilling in takes the user to
          the school level and drilling in again takes the user to the
          transaction level. Drilling in yet again, takes the user to the
          Transaction profile where the user can download the transaction
          data.`,
        ],
      },
      {
        header: 'Downloading the Report',
        body: [
          `The user may select Generate Excel or Generate PDF reports on any
          level of the Canceled Records Report Results panel. Generate Excel
          will create a spreadsheet which the user will download through the
          web browser. Generate PDF will create a PDF file which the user can
          print or save. In addition, once the user has drilled into the
          specific transaction profile level, the user may select Download in
          the Next Steps panel.`,
        ],
      },
    ];
  },
};
</script>
